(function(exports) {
  exports.noop = function(){};
})(typeof module === 'object' && typeof module.exports === 'object' ? module.exports : window);
